import { css } from "@emotion/css";
import { ReactNode } from "react";
import { Link } from "react-router-dom";
import tw from "src/utils/tw";
import { ClassNameValue } from "tailwind-merge";

interface Props {
  className?: string;
  onClick?: (e) => void;
  align?: string;
  to?: any;
  href?: string;
  target?: string;
  isPreview?: boolean;
  disabled?: boolean;
  children: ReactNode;
  style?: React.CSSProperties;
}

export default function LinkButton(props: Props) {
  const classNames: ClassNameValue = tw(
    "text-organization bg-none border-none cursor-pointer outline-none transition-all hover:text-organization",
    props.align === "right" && "float-right",
    props.disabled && "opacity-50 cursor-not-allowed",
    props.className
  );

  const styles = css`
    & .fa {
      position: relative;
      top: 1px;
    }
  `;

  if (props.to) {
    return (
      <Link
        to={props.to}
        className={tw(styles, classNames)}
        style={props.style}
        onClick={props.onClick}
      >
        {props.children}
      </Link>
    );
  }

  if (props.href) {
    return (
      <a
        href={props.href}
        className={tw(styles, classNames)}
        target={props.target}
        style={props.style}
      >
        {props.children}
      </a>
    );
  }

  return (
    <button
      className={tw(styles, classNames)}
      type="button"
      onClick={props.onClick}
      disabled={props.disabled}
      style={props.style}
    >
      {props.children}
    </button>
  );
}
